import { useEffect, useRef, useState } from 'react'
import { BASE_BACKEND_URL, fetchWithAuth } from '../../../auth'

const buildQuery = ({ startDate, endDate, buyer, productGroup }) => {
  const query = new URLSearchParams()

  if (startDate) query.set('start_date', startDate)
  if (endDate) query.set('end_date', endDate)
  if (buyer) query.set('buyer', buyer)
  if (productGroup) query.set('product_group', productGroup)

  return query.toString()
}

export const useFillRateProductDifferences = ({
  startDate,
  endDate,
  buyer,
  productGroup
}) => {
  const abortRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    filters: {},
    totals: {},
    results: [],
    errors: []
  })
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!startDate || !endDate || !buyer || !productGroup) return

    abortRef.current?.abort()

    const controller = new AbortController()
    abortRef.current = controller

    const fetchDifferences = async () => {
      setLoading(true)
      setError(null)

      try {
        const query = buildQuery({
          startDate,
          endDate,
          buyer,
          productGroup
        })
        const response = await fetchWithAuth(
          `${BASE_BACKEND_URL}/poc/fill_rates/product_differences?${query}`,
          { signal: controller.signal }
        )

        setData(response)
      } catch (e) {
        if (e.name !== 'AbortError') {
          console.error('Error loading fill rate product differences', e)
          setError(e)
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false)
        }
      }
    }

    fetchDifferences()

    return () => controller.abort()
  }, [buyer, endDate, productGroup, startDate])

  return { loading, data, error }
}
